module.exports = __webpack_public_path__ + "static/img/t.16d250f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/t.png
// module id = 571
// module chunks = 1